var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.6 13.6"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash_svg__Icon_-_Trash",
    "data-name": "Icon - Trash",
    transform: "translate(-38.345 -914.478)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__Line_1035",
    "data-name": "Line 1035",
    transform: "translate(39.095 917.375)",
    d: "M0 0h11.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__Path_5576",
    "data-name": "Path 5576",
    d: "M7.221.375H4.805A.805.805 0 004 1.18v1.342h4.026V1.18a.805.805 0 00-.805-.805z",
    transform: "translate(38.987 914.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__Line_1036",
    "data-name": "Line 1036",
    transform: "translate(43.255 920.193)",
    d: "M0 4.026V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__Line_1037",
    "data-name": "Line 1037",
    transform: "translate(46.745 920.193)",
    d: "M0 4.026V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__Path_5577",
    "data-name": "Path 5577",
    d: "M11.008 11.3a.8.8 0 01-.8.741H2.3a.8.8 0 01-.8-.741L.75 2.375h11z",
    transform: "translate(38.748 915)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMy42IDEzLjYiPgogIDxnIGlkPSJJY29uXy1fVHJhc2giIGRhdGEtbmFtZT0iSWNvbiAtIFRyYXNoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzguMzQ1IC05MTQuNDc4KSI+CiAgICA8bGluZSBpZD0iTGluZV8xMDM1IiBkYXRhLW5hbWU9IkxpbmUgMTAzNSIgeDI9IjExLjgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOS4wOTUgOTE3LjM3NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF81NTc2IiBkYXRhLW5hbWU9IlBhdGggNTU3NiIgZD0iTTcuMjIxLjM3NUg0LjgwNUEuODA1LjgwNSwwLDAsMCw0LDEuMThWMi41MjJIOC4wMjZWMS4xOEEuODA1LjgwNSwwLDAsMCw3LjIyMS4zNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOC45ODcgOTE0Ljg1MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8bGluZSBpZD0iTGluZV8xMDM2IiBkYXRhLW5hbWU9IkxpbmUgMTAzNiIgeTE9IjQuMDI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0My4yNTUgOTIwLjE5MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8bGluZSBpZD0iTGluZV8xMDM3IiBkYXRhLW5hbWU9IkxpbmUgMTAzNyIgeTE9IjQuMDI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Ni43NDUgOTIwLjE5MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF81NTc3IiBkYXRhLW5hbWU9IlBhdGggNTU3NyIgZD0iTTExLjAwOCwxMS4zYS44LjgsMCwwLDEtLjguNzQxSDIuM2EuOC44LDAsMCwxLS44LS43NDFMLjc1LDIuMzc1aDExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzguNzQ4IDkxNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgTrash as ReactComponent };